import { helpHref } from '@hoopoe/shared';
import { ArrowRight } from 'lucide-react';
import { cn } from '../../lib/cn';

/** "Learn more →" link to an Onboarding article (PLAN §12.3, §12.6). */
export function LearnMore({
  slug,
  section,
  className,
  label = 'Learn more',
}: {
  slug: string;
  section?: string;
  className?: string;
  label?: string;
}) {
  return (
    <a
      href={helpHref(slug, section)}
      className={cn('inline-flex items-center gap-1 text-xs font-medium underline underline-offset-2', className)}
    >
      {label}
      <ArrowRight className="size-3" aria-hidden="true" />
    </a>
  );
}
